// Generated file : do not modify
import { ContratModeCalculs } from '@/generated/classes/Contrat';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Simulation
export class StatSimu {
  // période
  public period: Date;
  // Nb simulations
  public nbSimu: number;
  // Nb utilisateurs'
  public nbUser: number;
  // Nb nouveaux utilisateurs
  public nbNewUser: number;

  constructor() {
    this.period = new Date(1901,1,1,0,0,0,0);
    this.nbSimu = 0;
    this.nbUser = 0;
    this.nbNewUser = 0;
  }
}

export default class Simulation  {
  // Identifiant unique
  public id: number;
  // IN : Nom
  public nom: string;
  // IN : Prenom
  public prenom: string;
  // IN : Adresse mail
  public email: string;
  // OUT : Nouvel utilisateur
  public newUser: boolean;
  // IN : Convention collective
  public convention: string;
  // ID convention
  public conventionId: number;
  // IN : Artiste = 1, Technicien = 0
  public artiste: boolean;
  // IN : OUI = 1, NON = 0
  public cadre: boolean;
  // IN : Durée du contrat
  public duree: number;
  // IN : Montant
  public montant: number;
  // IN : Mode de calcul : brut = 2, net = 3, total = 4
  public mode: ContratModeCalculs;
  // OUT : Montant brut
  public brut: number;
  // OUT : Charges salariales
  public salariales: number;
  // OUT : Montant net
  public net: number;
  // OUT : Charges patronales
  public patronales: number;
  // OUT : Coût employeur
  public cout: number;
  // OUT : Erreur, si présente pas de résultat
  public error: string;
  // OUT : Temps de calcul en ms
  public duration: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.nom = '';
    this.prenom = '';
    this.email = '';
    this.newUser = false;
    this.convention = '';
    this.conventionId = 0;
    this.artiste = false;
    this.cadre = false;
    this.duree = 0;
    this.montant = 0;
    this.mode = ContratModeCalculs.NONE;
    this.brut = 0;
    this.salariales = 0;
    this.net = 0;
    this.patronales = 0;
    this.cout = 0;
    this.error = '';
    this.duration = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Simulation): Simulation {
    const newSimulation: Simulation = new Simulation();
    newSimulation.id = obj.id;
    newSimulation.nom = obj.nom;
    newSimulation.prenom = obj.prenom;
    newSimulation.email = obj.email;
    newSimulation.newUser = obj.newUser;
    newSimulation.convention = obj.convention;
    newSimulation.conventionId = obj.conventionId;
    newSimulation.artiste = obj.artiste;
    newSimulation.cadre = obj.cadre;
    newSimulation.duree = obj.duree;
    newSimulation.montant = obj.montant;
    newSimulation.mode = obj.mode;
    newSimulation.brut = obj.brut;
    newSimulation.salariales = obj.salariales;
    newSimulation.net = obj.net;
    newSimulation.patronales = obj.patronales;
    newSimulation.cout = obj.cout;
    newSimulation.error = obj.error;
    newSimulation.duration = obj.duration;
    newSimulation.canUpdate = obj.canUpdate;
    newSimulation.canDelete = obj.canDelete;
    newSimulation.display = obj.display;
    newSimulation.notifDefType = obj.notifDefType;
    return newSimulation;
  }

  public toJsonSimulation (): string {
    const json = {
      nom: this.nom,
      prenom: this.prenom,
      email: this.email,
      newUser: this.newUser,
      convention: this.convention,
      conventionId: this.conventionId,
      artiste: this.artiste,
      cadre: this.cadre,
      duree: this.duree,
      montant: this.montant,
      mode: this.mode,
      brut: this.brut,
      salariales: this.salariales,
      net: this.net,
      patronales: this.patronales,
      cout: this.cout,
      error: this.error,
      duration: this.duration,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromSimulation (obj: Simulation): void {
    this.id = obj.id;
    this.nom = obj.nom;
    this.prenom = obj.prenom;
    this.email = obj.email;
    this.newUser = obj.newUser;
    this.convention = obj.convention;
    this.conventionId = obj.conventionId;
    this.artiste = obj.artiste;
    this.cadre = obj.cadre;
    this.duree = obj.duree;
    this.montant = obj.montant;
    this.mode = obj.mode;
    this.brut = obj.brut;
    this.salariales = obj.salariales;
    this.net = obj.net;
    this.patronales = obj.patronales;
    this.cout = obj.cout;
    this.error = obj.error;
    this.duration = obj.duration;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareSimulation (value: Simulation): boolean {
    return (this.toJsonSimulation() == value.toJsonSimulation());
  }

  public cloneSimulation (): Simulation {
    return Simulation.fromJson(this);
  }

  public static calcul (simulation: Simulation): Promise<Simulation> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/simulations/calcul', simulation, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Simulation.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static stats (): Promise<StatSimu[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/simulations/stats', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: StatSimu[] = [];
              res.data.forEach(( a: StatSimu ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static details (statSimu: StatSimu): Promise<Simulation[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/simulations/details', statSimu, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Simulation[] = [];
              res.data.forEach(( a: Simulation ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(simulations: Simulation[]) {
  }
}
